import React, {useState} from 'react';

const AuthButtons = (props) => {

    const [btn1Hover, setBtn1Hover] = useState(false)
    const [btn2Hover, setBtn2Hover] = useState(false)

    return (
        <>
        <div className="vertical-line mx-4 h-6 bg-gray-400"></div>
        
        <div className="flex gap-2">
            <a href='/login' className={` border-solid  border-[1px] bg-[transparent] transition-colors duration-300 px-6 py-2 rounded-[50px]`}
            onMouseEnter={() => setBtn1Hover(true)}
            onMouseLeave={() => setBtn1Hover(false)}
            style={{
                color: btn1Hover ? props.data.colors[0].colorWhite : props.color,
                backgroundColor: btn1Hover ? props.data.colors[0].colorGrey : '',
                borderColor: btn1Hover ? props.data.colors[0].colorGrey : props.color,
            }}>
                {props.data.authButtons[0].text}
            </a>
            <a href='/registration' className={`transition-colors duration-300 px-6 py-2 rounded-[50px]`}
            onMouseEnter={() => setBtn2Hover(true)}
            onMouseLeave={() => setBtn2Hover(false)}
            style={{
                color: btn2Hover ? props.data.colors[0].colorWhite : props.data.colors[0].colorGrey,
                backgroundColor: btn2Hover ? props.data.colors[0].colorGrey : props.data.colors[0].colorWhite
            }}>
            {props.data.authButtons[1].text}
            </a>
        </div>
        </>
    );
};

export default AuthButtons;